export const FLAG_GETTING_EXCHANGE_RATES = 'FLAG_GETTING_EXCHANGE_RATES';
export const GET_EXCHANGE_RATES = 'GET_EXCHANGE_RATES';
export const CLEAR_EXCHANGE_RATES = 'CLEAR_EXCHANGE_RATES';
export const FLAG_GETTING_EXCHANGE_RATE = 'FLAG_GETTING_EXCHANGE_RATE';
export const GET_EXCHANGE_RATE = 'GET_EXCHANGE_RATE';
export const CLEAR_EXCHANGE_RATE = 'CLEAR_EXCHANGE_RATE';